import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  NumberFormatter,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
  Drawer,
  SegmentedControl,
  Stack,
  SimpleGrid,
  CloseButton,
  Checkbox,
  MultiSelect,
  MultiSelectProps,
} from "@mantine/core";
import {
  IconActivity,
  IconBrandVisa,
  IconCheck,
  IconCoin,
  IconCopy,
  IconEdit,
  IconEye,
  IconHandClick,
  IconMenuOrder,
  IconReload,
  IconSandbox,
  IconSearch,
  IconSquareXFilled,
  IconStatusChange,
  IconVideo,
  IconAdjustmentsHorizontal,
  IconCalendar,
  IconDownload,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useMemo, useState, useTransition } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure, useHotkeys, useIsFirstRender } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconBrandBootstrap, IconTimeDuration15 } from "@tabler/icons-react";
import moment from "moment";
import * as XLSX from "xlsx";
import { useLocation, useNavigate } from "react-router-dom";
import {
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import useDynamicHeight from "../../../_base/component/Core/hookBase";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SocketExtension } from "../../../_base/socket/socket";
import { CREATEORDERSUCCESS } from "../../../_base/socket/ToplicList";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_POS } from "../../../config";
import { _localization } from "../../../config/location";
import { green, olive_green, sky_blue } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItem } from "../../../model/SelectListItem";
import DetailsSellView from "../DetailsSellView";
import { IconChecklist } from "@tabler/icons-react";
import { getValueById } from "../../../_base/helper/FunctionHelper";

// Định nghĩa đúng kiểu dữ liệu
type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const SEARCH_BY_OPTIONS = [
  { value: "orderNumber", label: "Mã đơn hàng", placeholder: "Nhập mã đơn hàng" },
  { value: "codeCustomer", label: "Mã khách hàng", placeholder: "Nhập mã khách hàng" },
  { value: "phone", label: "SĐT khách hàng", placeholder: "SĐT khách hàng / người mua" },
];

const DATE_TYPE_OPTIONS = [
  { value: "create", label: "Ngày lập" },
  { value: "finish", label: "Ngày hoàn thành" },
  { value: "outward", label: "Ngày xuất kho" },
];

const RECONCILE_OPTIONS = [
  { value: "", label: "Tất cả" },
  { value: "false", label: "Chưa đối soát" },
  { value: "true", label: "Đã đối soát" },
];

const ASSIGN_OPTIONS = [
  { label: "Đã phân công", value: "true" },
  { label: "Chưa phân công", value: "false" },
];

const SALE_CHANNEL_OPTIONS = [
  { label: "Lazada", value: "304" },
  { label: "Tiktok", value: "341" },
  { label: "Chat Zalo", value: "343" },
  { label: "Facebook", value: "62" },
  { label: "Shopee Mall", value: "63" },
  { label: "Shopee", value: "342" },
  { label: "Tổng đài", value: "66" },
  { label: "Khách đến showroom", value: "67" },
  { label: "Khách đặt đơn Website", value: "68" },
  { label: "Khách gọi điện cho nhân viên", value: "69" },
  { label: "Khách chat qua website", value: "101" },
];

// Dòng trong danh sách chọn nhiều: ô tích + tên, giống bộ lọc dạng checkbox
const renderCheckboxOption: MultiSelectProps["renderOption"] = ({
  option,
  checked,
}) => (
  <Group gap="xs" wrap="nowrap">
    <Checkbox
      checked={!!checked}
      onChange={() => {}}
      tabIndex={-1}
      style={{ pointerEvents: "none" }}
      aria-hidden
    />
    <span>{option.label}</span>
  </Group>
);

// Key lưu bộ lọc riêng của màn này, không dùng chung với các màn danh sách đơn khác
const keySearchListOrderCancelTMDT = "keySearchListOrderCancelTMDT";

const ListOrderCancelTMDT = () => {
  const navigate = useNavigate();
  const location = useLocation();

  //#region  table

  //data and fetching state
  const [isHaveNewOrder, setIsHaveNewOrder] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);
  const [listEmployeeSales, setListEmployeeSales] = useState<any[]>([]);
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const dataChannel = [
    {
      text: "Lazada",
      value: "304",
    },
    {
      text: "Tiktok",
      value: "341",
    },
    {
      text: "Chat Zalo",
      value: "343",
    },
    {
      text: "Facebook",
      value: "62",
    },
    {
      text: "Shopee Mall",
      value: "63",
    },
    {
      text: "Shopee",
      value: "342",
    },
    {
      text: "Tổng đài",
      value: "66",
    },
    {
      text: "Khách đến showroom",
      value: "67",
    },
    {
      text: "Khách đặt đơn Website",
      value: "68",
    },
    {
      text: "Khách gọi điện cho nhân viên",
      value: "69",
    },
    {
      text: "Khách chat qua website",
      value: "101",
    },
  ];

  const dataStatusGeneral = [
    { label: "Kho xuất hàng", value: "KHO_XUAT_HANG" },
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Test OK", value: "TEST_OK" },
    { label: "Đơn hàng hoàn thành", value: "DON_HANG_HOAN_THANH" },
    { label: "Đơn hàng tạm", value: "DON_HANG_TAM" },
    { label: "Thất bại do KH", value: "THAT_BAI_DO_KH" },
    { label: "KTKT đang kiểm tra", value: "KTKT_DANG_KIEM_TRA" },
    { label: "Đơn hàng chờ duyệt giảm", value: "DON_HANG_CHO_DUYET_GIAM" },
    { label: "Đơn chờ duyệt đổi trả", value: "DON_CHO_DUYET_DOI_TRA" },
    { label: "Đơn đã duyệt đổi trả", value: "DON_DA_DUYET_DOI_TRA" },
    { label: "GV thành công", value: "GV_THANH_CONG" },
    { label: "Nhập lại", value: "NHAP_LAI" },
    { label: "Đã phân công GV", value: "DA_PHAN_CONG_GV" },
    { label: "GV đến nơi", value: "GV_DEN_NOI" },
    { label: "GV đang giao", value: "GV_DANG_GIAO" },
    { label: "Test lỗi", value: "TEST_LOI" },
    { label: "Đã phân công KTKT", value: "DA_PHAN_CONG_KTKT" },
    { label: "Hủy phân công GV", value: "HUY_PHAN_CONG_GV" },
    { label: "Thất bại do HACOM", value: "THAT_BAI_DO_HACOM" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
    { label: "Đơn hàng chốt", value: "DON_HANG_CHOT" },
    { label: "Đơn hàng đã duyệt giảm", value: "DON_HANG_DA_DUYET_GIAM" },
    { label: "GV tiếp nhận", value: "GV_TIEP_NHAN" },
    { label: "GV nhập lại", value: "GV_NHAP_LAI" },
    { label: "GV nhập lại một phần", value: "GV_NHAP_LAI_MOT_PHAN" },
    { label: "GV thất bại do HACOM", value: "GV_THAT_BAI_DO_HACOM" },
    { label: "GV thất bại do KH", value: "GV_THAT_BAI_DO_KH" },
    { label: "GV nối chuyến", value: "GV_NOI_CHUYEN" },
    { label: "Hủy phân công KTKT", value: "HUY_PHAN_CONG_KTKT" },
    { label: "Có nhập lại", value: "CO_NHAP_LAI" },
    { label: "KH đã nhận", value: "DA_NHAN" },
  ];

  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const _searchJson = sessionStorage.getItem(keySearchListOrderCancelTMDT)
    ? JSON.parse(sessionStorage.getItem(keySearchListOrderCancelTMDT) ?? "")
    : null;
  const firstRender = useIsFirstRender();
  //table state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  } as MRT_PaginationState);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const height = useDynamicHeight(290);
  const innitSearchReturn = {
    customerName: "",
    customerCode: "",
    customerTaxCode: "",
    serial: "",
    orderNumber: "",
    phone: "",
    keySearch: "",
    codeSal: "",
  };

  const idUserlogin = JSON.parse(localStorage.getItem("empId") || "{}");

  // console.log("_searchJson", _searchJson);
  const innitStateSearch = useMemo(
    () => ({
      invId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.InvId as string)
          : "",
      invOutwardId:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.InvOutwardId
          : "",
      customerId: firstRender && _searchJson ? _searchJson.CustomerId : "",
      StartDate:
        firstRender && _searchJson && _searchJson.StartDate && checkedPinSearch
          ? new Date(_searchJson.StartDate)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() - 9)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      EndDate:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.EndDate &&
        _searchJson.EndDate != null
          ? new Date(_searchJson.EndDate)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      orderStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderStatus
          : "",
      orderType:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderType
          : "",
      orderNumber:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderNumber
          : "",
      paymentStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.PaymentStatus
          : "",
      industry:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.Industry
          : "",
      keySearch:
        checkedPinSearch && firstRender && _searchJson && checkedPinSearch
          ? _searchJson.KeySearch
          : "",
      OutwardStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OutwardStatus
          : "",
      codeCustomer:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.CodeCustomer
          : "",
      phone:
        checkedPinSearch && firstRender && _searchJson ? _searchJson.Phone : "",
      createBy:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.CreateBy
          : "",
      //Người hưởng số
      CodeSal:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CodeSal as string)
          : "",
      //Thời gian hoàn thành đơn
      FinishDate:
        firstRender && _searchJson && _searchJson.FinishDate && checkedPinSearch
          ? new Date(_searchJson.FinishDate)
          : null,
      //Ngày xuất kho
      OwDate:
        firstRender && _searchJson && _searchJson.OwDate && checkedPinSearch
          ? new Date(_searchJson.OwDate)
          : null,
      // Số điện thoại người bán
      SalePhone:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.SalePhone
          : "",
      // Mã voucher
      VourcherCode:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.VourcherCode
          : "",
      //Tình trạng phân công
      IsAssigned:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.IsAssigned
          : "",
      // Lọc theo kênh bán
      //Đối soát
      AttributeValue7:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.AttributeValue7
          : "",
      //Kênh bán
      saleChannelId:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.saleChannelId
          : "",
      //Trạng thái đơn hàng TMĐT
      Attribute58:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.Attribute58
          : "",
      //Trạng thái chung
      // Chọn nhiều: lưu dạng mảng, gửi lên API cách nhau dấu phẩy
      Attribute12:
        checkedPinSearch && firstRender && _searchJson?.Attribute12
          ? String(_searchJson.Attribute12).split(",")
          : ([] as string[]),
    }),
    [firstRender, _searchJson],
  );

  const [searchReturn, setSearchReturn] = useState({
    ...innitSearchReturn,
  });
  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });
  // const [search, setSearch] = useState({
  //   ...innitStateSearch,
  // });
  // useEffect(() => {
  //   setSearch(innitStateSearch);
  // }, []);
  const [refreshKeySearch, setRefreshKeySearch] = useState<any>({});

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const getTextStatus = (row: any) => {
    return orderStatuses.find(
      (status) => status.value === row.original.orderStatus,
    )?.label;
  };

  //#region biến DL tĩnh
  const getShippingVendorText = (shippingVendor: string) => {
    switch (shippingVendor) {
      case "KHONG":
        return "Nhận tại cửa hàng";
      case "HACOM":
        return "Nội bộ";
      default:
        return shippingVendor;
    }
  };

  const TMDT_STATUS_MAP: Record<string | number, string> = {
    0: "Mới",
    17: "Chờ xác nhận",
    11: "Chờ hàng",
    12: "Chờ in",
    13: "Đã in",
    20: "Đã đặt hàng",
    1: "Đã xác nhận",
    8: "Đang đóng hàng",
    9: "Chờ chuyển hàng",
    2: "Đã gửi hàng",
    3: "Đã nhận",
    16: "Đã thu tiền",
    4: "Đang hoàn",
    15: "Hoàn một phần",
    5: "Đã hoàn",
    6: "Đã huỷ",
    7: "Đã xoá",
    CHO_LAY_HANG: "Chờ lấy hàng",
  };

  const getDataAtt58 = (value: string | number) => {
    if (value === null || value === undefined) return "";
    return TMDT_STATUS_MAP[value] || value;
  };

  const getDataDeliveryStatus = (value: string | null) => {
    switch (value) {
      case null:
        return "Không yêu cầu";
      case "THANH_CONG":
        return "Thành công";
      case "PHAN_CONG":
        return "Phân công";
      case "TAO_MOI":
        return "Tạo mới";
      case "THAT_BAI_DO_KH":
        return "Thất bại do khách hàng";
      case "NHAP_LAI":
        return "Nhập lại";
      case "DEN_NOI":
        return "Đến nơi";
      case "DANG_GIAO":
        return "Đang giao";
      case "DA_YEU_CAU":
        return "Đã yêu cầu";
      case "HUY_PHAN_CONG":
        return "Hủy phân công";
      case "THAT_BAI_DO_HACOM":
        return "Thất bại do HACOM";
      case "TIEP_NHAN":
        return "Tiếp nhận";
      case "NHAP_LAI_MOT_PHAN":
        return "Nhập lại một phần";
      case "NOI_CHUYEN":
        return "Nối chuyến";
    }
  };
  const orderTypes = [
    { value: "1", label: "Bán buôn", color: "yellow" },
    { value: "2", label: "Bán lẻ", color: "indigo" },
    { value: "3", label: "Đơn đổi trả", color: "green" },
    { value: "4", label: "Đơn online", color: "blue" },
  ];

  const orderStatuses = [
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn chờ duyệt giảm" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
    { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
  ];

  const warehouseStatus = [
    { value: "DA_YEU_CAU", label: "Đã yêu cầu" },
    { value: "DANG_XUAT", label: "Đang xuất" },
    { value: "DA_XUAT", label: "Đã xuất" },
    { value: "DANG_NHAP", label: "Đang nhập" },
    { value: "DA_NHAP", label: "Đã nhập" },
  ];

  // Danh sách kênh bán
  const saleChannelsList = [
    { id: 1, label: "Admin" },
    { id: 2, label: "Website" },
    { id: 10, label: "API" },
    { id: 20, label: "Facebook (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
    { id: 21, label: "Instagram (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
    { id: 41, label: "Lazada.vn" },
    { id: 42, label: "Shopee.vn" },
    { id: 43, label: "Sendo.vn" },
    { id: 45, label: "Tiki.vn" },
    { id: 46, label: "Zalo Shop" },
    { id: 47, label: "1Landing.vn" },
    { id: 48, label: "Tiktok Shop" },
    { id: 49, label: "Zalo OA (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
    { id: 50, label: "Shopee Chat (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
    { id: 51, label: "Lazada Chat (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
    { id: 52, label: "Zalo cá nhân (Khi tạo đơn hàng từ vpage.nhanh.vn)" },
  ];
  // #endregion biến DL tĩnh

  // Xem chi tiết đơn hàng
  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      navigate("/sell/retail-order-tmdt", {
        state: {
          id: row.original.id,
          orderNumber: row.original.orderNumber,
          orderType: row.original.orderType,
          actionType: "view",
          fromTMDTList: true, // Thêm flag để nhận biết từ màn hình TMDT
        },
      });
    }
  };

  // Fetch lấy dữ liệu đơn hàng
  // Tham số lọc hiện tại (không gồm Skip/Take), dùng chung cho tìm kiếm và export Excel
  const buildSearchParams = () => {
    const search = form.getValues();
    return {
      InvId: search.invId?.toString(),
      InvOutwardId: search.invOutwardId?.toString(),
      CustomerId: search.customerId?.toString(),
      StartDate: search.StartDate
        ? moment(search?.StartDate).format("YYYY-MM-DDT00:00:00.000[Z]")
        : "",
      EndDate: search.EndDate
        ? moment(search?.EndDate).format("YYYY-MM-DDT00:00:00.000[Z]")
        : "",
      OrderStatus: search.orderStatus?.toString(),
      OrderType: search.orderType ? search.orderType?.toString() : "",
      OrderNumber: search.orderNumber?.toString(),
      PaymentStatus: search.paymentStatus?.toString(),
      industry: search.industry?.toString(),
      KeySearch: search.keySearch?.toString(),
      CodeCustomer: search.codeCustomer?.toString(), // Thêm trường tìm kiếm mã khách hàng
      Phone: search.phone?.toString(), // Thêm trường tìm kiếm số điện thoại
      CreateBy: search.createBy?.toString(), // Thêm trường tìm kiếm người tạo
      CodeSal: search.CodeSal?.toString(), //Thêm người hưởng số
      FinishDate: search.FinishDate
        ? moment(search?.FinishDate).format("YYYY-MM-DDT00:00:00.000[Z]")
        : "", //Thời gian hoàn thành đơn
      OwDate: search.OwDate
        ? moment(search?.OwDate).format("YYYY-MM-DDT00:00:00.000[Z]")
        : "", //ngày xuất kho
      SalePhone: search.SalePhone?.toString(), // Số điện thoại người bán
      VourcherCode: search.VourcherCode?.toString(), // Mã voucher
      saleChannelId: search.saleChannelId?.toString(),
      AttributeValue7: search.AttributeValue7?.toString(),
      Attribute12: (search.Attribute12 ?? []).join(","), // Trạng thái chung (chọn nhiều)
    };
  };

  const fetchData = async () => {
    setIsLoading(true);
    //   setIsRefetching(true);
    // setIsError(false);

    let queryParams = {
      Skip:
        firstRender && _searchJson
          ? _searchJson.Skip
          : pagination.pageIndex * pagination.pageSize,
      Take: firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
    } as any;
    try {
      // if (!firstRender) {
      queryParams = { ...queryParams, ...buildSearchParams() };
      // } else {
      //   const _searchJson = localStorage.getItem(keySearchListOrderCancelTMDT);
      //   if (_searchJson) {
      //     const _search = JSON.parse(_searchJson);
      //     if (_search) queryParams = _search;
      //   }
      // }

      const url =
        "/api/v1/CreateSellItem/get-list-order-cancel-tmdt?" +
        Object.entries(queryParams)
          .filter(([, value]) => value !== undefined && value !== "")
          .map(
            ([key, value]) =>
              `${key}=${encodeURIComponent(
                value as string | number | boolean,
              )}`,
          )
          .join("&");
      //   console.log(queryParams);
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        setData(response.data?.pagedList?.lists);
        startTransition(() => {
          setRowCount(response.totalCount);
          //     table.resetRowSelection();
        });
      }
    } catch (error) {
      //   setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      //   setIsRefetching(false);
      sessionStorage.setItem(
        keySearchListOrderCancelTMDT,
        JSON.stringify(queryParams),
      );
    }
  };

  // Xem danh sách sản phẩm trong đơn hàng
  const openModal = (document: any, amount: number, order: string) =>
    modals.openConfirmModal({
      title: <Title order={4}>Danh sách sản phẩm trong đơn: {order}</Title>,
      children: <DetailsSellView e={document} amount={amount} />,
      size: "100%",
      radius: "md",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 80,
        // enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
      },
      {
        accessorKey: "invOrgName",
        header: "Chi nhánh",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 220,
        Cell: ({ row }) => (
          <>
            {row.original.invOrgCode
              ? `${row.original.invOrgCode} - ${row.original.invOrgName}`
              : row.original.invOrgName}
          </>
        ),
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => handleCheckView(row)}
            >
              {renderedCellValue === null ? "KHÔNG HỢP LỆ" : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "attribute49",
        header: "Mã đơn hàng kênh bán",
        size: 200,
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute82",
        header: "Mã vận đơn",
        size: 200,
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      // {
      //   accessorKey: "attribute74",
      //   header: "Kênh bán",
      //   size: 150,
      //   enableColumnFilter: false,
      //   Cell: ({ row }) => {
      //     const found = saleChannelsList.find(
      //       (c) => c.id === Number(row.original.attribute74)
      //     );
      //     return found ? found.label : row.original.attribute74;
      //   },
      // },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => {
          const orderStatus = row.original.orderStatus;
          let badgeColor;
          switch (orderStatus) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_CHOT":
              badgeColor = "violet";
              break;
            case "DON_HANG_DOI_TRA_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "DON_HANG_DOI_TRA":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "DON_HANG_CHO_DUYET_GIAM":
              badgeColor = olive_green.light;
              break;
            case "DON_HANG_DA_DUYET_GIAM":
              badgeColor = olive_green.medium;
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "DON_HANG_DONG":
              badgeColor = "red";
              break;
            default:
              badgeColor = "gray";
          }
          return (
            <Badge
              size="md"
              color={badgeColor}
              fs={"12,5px"}
              fw={"bold"}
              radius="sm"
            >
              {row.original.orderStatus !== null
                ? getTextStatus(row)
                : "Không HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute58",
        header: "Trạng thái đơn hàng TMĐT",
        size: 240,
        Cell: ({ renderedCellValue }) => (
          <Text size="sm" fw={500} tt={"uppercase"}>
            {getDataAtt58(renderedCellValue?.toString() ?? "")}
          </Text>
        ),
      },
      {
        accessorKey: "trangThaiDoiSoat",
        header: "Trạng thái đối soát",
        Cell: ({ row }) =>
          String(row.original.saleChannelId) === "341" ? (
            row.original.attributeValue7 && row.original.attributeValue7 > 0 ? (
              <Badge color="green">Đã đối soát</Badge>
            ) : (
              <Badge color="orange">Chưa đối soát</Badge>
            )
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "attribute12",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataStatusGeneral,
              "label",
            )?.toUpperCase() || renderedCellValue}
          </Text>
        ),
      },
      {
        accessorKey: "attribute53",
        header: "Trạng thái phân công",
        enableColumnFilter: false,
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <Text size="sm" fw={500} tt={"uppercase"}>
            {renderedCellValue === "CHUA_PHAN_CONG"
              ? "Chưa phân công"
              : renderedCellValue === "DA_PHAN_CONG"
                ? "Đã phân công"
                : renderedCellValue === "DA_TIEP_NHAN"
                  ? "Đã tiếp nhận"
                  : ""}
          </Text>
        ),
      },
      {
        accessorKey: "attribute3",
        header: "Trạng thái kho",
        Cell: ({ renderedCellValue, row }) => {
          const _status = warehouseStatus.find(
            (status) => status.value === row?.original?.attribute3?.toString(),
          );

          return (
            <Badge size="sm" color="cyan">
              {_status?.label ? _status.label : "Chưa yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "inwardOrderNumbers",
        header: "Mã đơn nhập đổi trả",
        size: 200,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "inwardWarehouseStatuses",
        header: "Trạng thái kho đơn nhập đổi trả",
        size: 240,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute37",
        header: "Ngày xuất kho",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "orderType",
        header: "Loại đơn hàng",
        size: 150,
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const orderType = orderTypes.find(
            (type) => type.value === row.original.orderType?.toString(),
          );

          return (
            <Badge color={orderType?.color || "gray"}>
              {orderType?.label || "KHÔNG HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute16",
        header: "Mã ĐTCN",
        size: 150,
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "saleChannelId",
        header: "Kênh bán",
        Cell: ({ renderedCellValue }) => {
          const saleChannel = dataChannel.find(
            (channel) => channel.value === renderedCellValue?.toString(),
          );
          return saleChannel?.text || "KHÔNG HỢP LỆ";
        },
      },

      {
        accessorKey: "sale",
        header: "Nhân viên bán hàng",
        size: 180,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ renderedCellValue }) => (
        //   <>
        //     <AvatarUtils
        //       value={renderedCellValue?.toString().split("-")[0] ?? ""}
        //     />
        //   </>
        // ),
      },
      {
        accessorKey: "nvhs",
        header: "Người hưởng số",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "salePhone",
        header: "Số đt người bán",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },

      {
        accessorKey: "creator",
        header: "Người tạo đơn đổi trả",
        // enableColumnActions: false,,
        size: 200,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          // Kiểm tra nếu orderType === 3 thì hiển thị, ngược lại không hiển thị
          return row.original.orderType == 3 ? <>{row.original.creator}</> : "";
        },
      },
      // {
      //   accessorKey: "attribute18",
      //   header: "Người hưởng doanh số",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      //   Cell: ({ renderedCellValue }) => (
      //     <>
      //       <AvatarUtils
      //         value={renderedCellValue?.toString().split("-")[0] ?? ""}
      //       />
      //     </>
      //   ),
      // },
      {
        accessorKey: "creationDate",
        header: "Ngày lập",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "orderDate",
        header: "Ngày hoàn thành",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      // {
      //   accessorKey: "address",
      //   header: "Địa chỉ",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      // },
      {
        accessorKey: "technicalChecked",
        header: "Dịch vụ kiểm tra",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => (
          <>
            {
              <>
                {(() => {
                  if (row.original.technicalChecked === 0) {
                    return <Badge color="indigo">Không yêu cầu</Badge>;
                  } else if (row.original.technicalChecked === 1) {
                    return <Badge color="grape">Lắp ráp(mới)</Badge>;
                  } else if (row.original.technicalChecked === 2) {
                    return <Badge color="cyan">Kiểm tra(mới)</Badge>;
                  } else if (row.original.technicalChecked === 3) {
                    return (
                      <Badge color={sky_blue.medium}>
                        Lắp ráp(mới)+Kiểm tra(mới)
                      </Badge>
                    );
                  } else {
                    return null; // Or any fallback UI if needed
                  }
                })()}
              </>
            }
          </>
        ),
      },
      {
        accessorKey: "attribute11",
        header: "KT đã kiểm tra",
        size: 260,
        Cell: ({ row }) => (
          <Badge color="blue">
            {row?.original?.attribute11
              ? row?.original?.attribute11
              : "Khách không yêu cầu kiểm tra"}
          </Badge>
        ),
      },
      {
        accessorKey: "deliveryStatus",
        header: "Trạng thái giao vận",
        Cell: ({ renderedCellValue }) => (
          <Text size="sm" fw={500} tt={"uppercase"}>
            {getDataDeliveryStatus(renderedCellValue?.toString() ?? null)}
          </Text>
        ),
      },
      {
        accessorKey: "shipingVendor",
        header: "Bộ phận giao hàng",
        // enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{getShippingVendorText(row?.original?.shipingVendor ?? "")}</>
        ),
      },
      {
        accessorKey: "tenNVGV",
        header: "Tên NV giao vận",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "sdtNVGV",
        header: "SĐT NV giao vận",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute46",
        header: "Thời gian GV tiếp nhận đơn",
        enableColumnFilter: false,
        size: 225,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "attribute45",
        header: "Thời gian GV hoàn thành đơn",
        enableColumnFilter: false,
        size: 240,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },

      {
        accessorKey: "customerName",
        header: "Tên khách hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ renderedCellValue, cell }) => (
        //   <Badge radius="xs" variant="light" leftSection={<IconPhoneCall />}>
        //     {renderedCellValue}
        //   </Badge>
        // ),
      },
      {
        accessorKey: "customerPhone",
        header: "Điện thoại KH",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ renderedCellValue, cell }) => (
        //   <Badge radius="xs" variant="light" leftSection={<IconPhoneCall />}>
        //     {renderedCellValue}
        //   </Badge>
        // ),
      },
      // {
      //   accessorKey: "htttPriority",
      //   header: "HTTT dự kiến",
      // },
      {
        accessorKey: "totalAmount",
        header: "Tổng tiền hàng",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let listAdd = row.original.orderDetail || [];
          let priceTotal = 0;
          listAdd?.forEach((item: any) => {
            priceTotal += (item?.priceOnPriceList || 0) * (item?.quality || 0);
          });
          return (
            <NumberFormatter
              value={priceTotal}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "totalPromotion",
        header: "Giảm giá",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let listAdd = row.original.orderDetail || [];
          const totalDiscount = listAdd.reduce((acc: number, item: any) => {
            const discountAmount = item.discountAmount || 0;
            return acc + discountAmount * (item.quality || 1);
          }, 0);
          const totalDiscountRate = listAdd.reduce((acc: number, item: any) => {
            const discountRate = item.discountRate || 0;
            const price = item.priceOnPriceList || 0;
            const quality = item.quality || 1;
            const discountValue = (discountRate / 100) * price * quality;
            return acc + discountValue;
          }, 0);
          const totalPromotionOrder = totalDiscount + totalDiscountRate;
          return (
            <NumberFormatter
              value={totalPromotionOrder}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "amountAfterDiscount",
        header: "Sau giảm giá",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let listAdd = row.original.orderDetail || [];
          let priceTotal = 0;
          listAdd?.forEach((item: any) => {
            priceTotal += (item?.priceOnPriceList || 0) * (item?.quality || 0);
          });
          const totalDiscount = listAdd.reduce((acc: number, item: any) => {
            const discountAmount = item.discountAmount || 0;
            return acc + discountAmount * (item.quality || 1);
          }, 0);
          const totalDiscountRate = listAdd.reduce((acc: number, item: any) => {
            const discountRate = item.discountRate || 0;
            const price = item.priceOnPriceList || 0;
            const quality = item.quality || 1;
            const discountValue = (discountRate / 100) * price * quality;
            return acc + discountValue;
          }, 0);
          const totalPromotionOrder = totalDiscount + totalDiscountRate;
          const displayTotalAmount = priceTotal;
          const amountAfterDiscount = Math.max(
            displayTotalAmount - totalPromotionOrder,
            0,
          );
          return (
            <NumberFormatter
              value={amountAfterDiscount}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "amountDiscountTotal",
        header: "Tổng phí sàn",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let listAdd = row.original.orderDetail || [];
          let sumAttr28 = listAdd.reduce(
            (sum: number, item: any) => sum + (Number(item.attribute28) || 0),
            0,
          );
          const totalFloorFee =
            Number(row.original.amountDiscountTotal ?? 0) || sumAttr28 || 0;
          return (
            <NumberFormatter
              value={totalFloorFee === 0 ? 0 : `-${Math.abs(totalFloorFee)}`}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "attributeValue7",
        header: "Phí sàn cập nhật sau",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let floorFeeAfter = Number(
            row.original.attributevalue7 ??
              row.original.attributeValue7 ??
              row.original.attribute17 ??
              0,
          );
          if (isNaN(floorFeeAfter)) floorFeeAfter = 0;
          return (
            <NumberFormatter
              value={floorFeeAfter === 0 ? 0 : `-${Math.abs(floorFeeAfter)}`}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "amount",
        header: "Số tiền cần thanh toán",
        size: 160,

        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            // suffix=" ₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "paid",
        header: "Đã trả",
        size: 160,

        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            // suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "remaining",
        header: "Còn nợ",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            // suffix=" ₫"
            thousandSeparator=","
          />
        ),
      },
      {
        accessorKey: "attribute39",
        header: "Mã voucher",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute27",
        header: "Số hóa đơn",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "printInvoiceCheck",
        header: "Xuất hóa đơn",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) => <>{row.original.printInvoiceCheck}</>,
      },

      // {
      //   accessorKey: "lastEditor",
      //   header: "Người chỉnh sửa cuối cùng",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      // },

      {
        accessorKey: "attribute60",
        header: "Lý do hủy đơn",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableResizing: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 80,
        Cell: ({ row }) => (
          <Flex gap={10}>
            <Tooltip label="Danh sách sản phẩm trong đơn">
              <ActionIcon
                variant="light"
                aria-label="Danh sách sản phẩm trong đơn"
                color="blue"
                onClick={() =>
                  openModal(
                    row.original.orderDetail,
                    row.original.amount,
                    row.original.orderNumber,
                  )
                }
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [location.pathname],
  );

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "invOrgName", "orderNumber"],
        right: ["action"],
        // ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableExpanding: false,
    // onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      // showAlertBanner: isError,
      // showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
      // columnPinning,
    },
    // onColumnPinningChange: (newState) => {
    //   setColumnPinning(newState);
    // },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // displayColumnDefOptions: {
    //   "mrt-row-select": {
    //     size: 1,
    //   },
    //   "mrt-row-expand": {
    //     size: 1,
    //   },
    // },
  });

  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch",
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };


  useEffect(() => {
    fetchData();
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    deleteViewStatus,
    refreshKeySearch,
  ]);

  useEffect(() => {
    SocketExtension.On(CREATEORDERSUCCESS, (arg: any) => {
      // fetchData();
      setIsHaveNewOrder(true);
    });
    return () => {
      SocketExtension.Off(CREATEORDERSUCCESS, () => {});
    };
  }, []);

  const renderSelectOption: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={orderTypes.find((x) => x.value === option.value)?.color}
        radius="sm"
        variant="filled"
      ></Badge>
      {option.label}{" "}
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  // // Lấy key search vào ở local storage
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    startTransition(() => {
      fetchDataBranch();
    });
  }, []);

  useEffect(() => {
    if (!checkedPinSearch) {
      form.setValues((prev) => ({ ...prev, keySearch: "" }));
    }
  }, [checkedPinSearch]);
  useHotkeys([["Enter", () => fetchData()]]);

  useEffect(() => {
    const fetchEmployeeBy = async () => {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmEmployee/get-all`,
      );
      if (response && response.success) {
        const result = response.data;
        const formattedData = result.map((employee: any) => ({
          value: employee.code, // Giá trị cho "value"
          label: `${employee.fullname}-${employee.code}`, // Giá trị cho "label"
        }));
        // Lọc trùng theo "value": mỗi value chỉ giữ lại 1 object đầu tiên
        const uniqueData = Array.from(
          new Map(
            formattedData.map((item: any) => [item.value, item]),
          ).values(),
        );
        setListEmployeeSales(uniqueData); // Lưu mảng đã format (đã lọc trùng) vào state
      }
    };
    fetchEmployeeBy();
  }, []);

  // Export Excel: lấy toàn bộ kết quả theo bộ lọc hiện tại, các cột và giá trị giống lưới
  const ExportExcel = async () => {
    const pageSize = 500;
    const params = buildSearchParams() as any;

    // Cột "Tổng tiền hàng", "Giảm giá"... lưới tự tính từ chi tiết đơn
    const detailsOf = (r: any): any[] => r.orderDetail || [];
    const totalAmountOf = (r: any) =>
      detailsOf(r).reduce(
        (sum, d) => sum + (d?.priceOnPriceList || 0) * (d?.quality || 0),
        0,
      );
    const totalPromotionOf = (r: any) =>
      detailsOf(r).reduce((sum, d) => {
        const discountAmount = (d.discountAmount || 0) * (d.quality || 1);
        const discountRate =
          ((d.discountRate || 0) / 100) *
          (d.priceOnPriceList || 0) *
          (d.quality || 1);
        return sum + discountAmount + discountRate;
      }, 0);
    const negative = (value: number) =>
      value === 0 ? 0 : -Math.abs(value);
    const dateText = (value: any) =>
      typeof value === "string" || value instanceof Date
        ? formatDateTransfer(value)
        : "";

    const columns: {
      header: string;
      width: number;
      value: (r: any, index: number) => string | number;
    }[] = [
      { header: "STT", width: 6, value: (_r, i) => i + 1 },
      {
        header: "Chi nhánh",
        width: 32,
        value: (r) =>
          r.invOrgCode ? `${r.invOrgCode} - ${r.invOrgName}` : (r.invOrgName ?? ""),
      },
      { header: "Mã đơn hàng", width: 18, value: (r) => r.orderNumber ?? "" },
      {
        header: "Mã đơn hàng kênh bán",
        width: 24,
        value: (r) => r.attribute49 ?? "",
      },
      { header: "Mã vận đơn", width: 22, value: (r) => r.attribute82 ?? "" },
      {
        header: "Trạng thái đơn hàng",
        width: 24,
        value: (r) =>
          r.orderStatus !== null
            ? (getTextStatus({ original: r }) ?? "")
            : "Không HỢP LỆ",
      },
      {
        header: "Trạng thái đơn hàng TMĐT",
        width: 24,
        value: (r) => String(getDataAtt58(r.attribute58?.toString() ?? "") ?? ""),
      },
      {
        header: "Trạng thái đối soát",
        width: 20,
        value: (r) =>
          String(r.saleChannelId) === "341"
            ? r.attributeValue7 && r.attributeValue7 > 0
              ? "Đã đối soát"
              : "Chưa đối soát"
            : "",
      },
      {
        header: "Trạng thái chung",
        width: 24,
        value: (r) =>
          getValueById(
            r.attribute12?.toString() ?? "",
            dataStatusGeneral,
            "label",
          )?.toUpperCase() ||
          r.attribute12 ||
          "",
      },
      {
        header: "Trạng thái phân công",
        width: 22,
        value: (r) =>
          r.attribute53 === "CHUA_PHAN_CONG"
            ? "Chưa phân công"
            : r.attribute53 === "DA_PHAN_CONG"
              ? "Đã phân công"
              : r.attribute53 === "DA_TIEP_NHAN"
                ? "Đã tiếp nhận"
                : "",
      },
      {
        header: "Trạng thái kho",
        width: 18,
        value: (r) =>
          warehouseStatus.find(
            (status) => status.value === r.attribute3?.toString(),
          )?.label || "Chưa yêu cầu",
      },
      {
        header: "Mã đơn nhập đổi trả",
        width: 26,
        value: (r) => r.inwardOrderNumbers ?? "",
      },
      {
        header: "Trạng thái kho đơn nhập đổi trả",
        width: 26,
        value: (r) => r.inwardWarehouseStatuses ?? "",
      },
      { header: "Ngày xuất kho", width: 20, value: (r) => dateText(r.attribute37) },
      {
        header: "Loại đơn hàng",
        width: 16,
        value: (r) =>
          orderTypes.find((type) => type.value === r.orderType?.toString())
            ?.label || "KHÔNG HỢP LỆ",
      },
      { header: "Mã ĐTCN", width: 14, value: (r) => r.attribute16 ?? "" },
      {
        header: "Kênh bán",
        width: 18,
        value: (r) =>
          dataChannel.find(
            (channel) => channel.value === r.saleChannelId?.toString(),
          )?.text || "KHÔNG HỢP LỆ",
      },
      { header: "Nhân viên bán hàng", width: 24, value: (r) => r.sale ?? "" },
      { header: "Người hưởng số", width: 24, value: (r) => r.nvhs ?? "" },
      { header: "Số đt người bán", width: 16, value: (r) => r.salePhone ?? "" },
      {
        header: "Người tạo đơn đổi trả",
        width: 24,
        value: (r) => (r.orderType == 3 ? (r.creator ?? "") : ""),
      },
      { header: "Ngày lập", width: 20, value: (r) => dateText(r.creationDate) },
      { header: "Ngày hoàn thành", width: 20, value: (r) => dateText(r.orderDate) },
      {
        header: "Dịch vụ kiểm tra",
        width: 26,
        value: (r) =>
          r.technicalChecked === 0
            ? "Không yêu cầu"
            : r.technicalChecked === 1
              ? "Lắp ráp(mới)"
              : r.technicalChecked === 2
                ? "Kiểm tra(mới)"
                : r.technicalChecked === 3
                  ? "Lắp ráp(mới)+Kiểm tra(mới)"
                  : "",
      },
      {
        header: "KT đã kiểm tra",
        width: 26,
        value: (r) => r.attribute11 || "Khách không yêu cầu kiểm tra",
      },
      {
        header: "Trạng thái giao vận",
        width: 22,
        value: (r) => getDataDeliveryStatus(r.deliveryStatus?.toString() ?? null) ?? "",
      },
      {
        header: "Bộ phận giao hàng",
        width: 20,
        value: (r) => getShippingVendorText(r.shipingVendor ?? ""),
      },
      { header: "Tên NV giao vận", width: 22, value: (r) => r.tenNVGV ?? "" },
      { header: "SĐT NV giao vận", width: 16, value: (r) => r.sdtNVGV ?? "" },
      {
        header: "Thời gian GV tiếp nhận đơn",
        width: 24,
        value: (r) => dateText(r.attribute46),
      },
      {
        header: "Thời gian GV hoàn thành đơn",
        width: 24,
        value: (r) => dateText(r.attribute45),
      },
      { header: "Tên khách hàng", width: 26, value: (r) => r.customerName ?? "" },
      { header: "Điện thoại KH", width: 16, value: (r) => r.customerPhone ?? "" },
      { header: "Tổng tiền hàng", width: 16, value: (r) => totalAmountOf(r) },
      { header: "Giảm giá", width: 16, value: (r) => totalPromotionOf(r) },
      {
        header: "Sau giảm giá",
        width: 16,
        value: (r) => Math.max(totalAmountOf(r) - totalPromotionOf(r), 0),
      },
      {
        header: "Tổng phí sàn",
        width: 16,
        value: (r) => {
          const sumAttr28 = detailsOf(r).reduce(
            (sum, d) => sum + (Number(d.attribute28) || 0),
            0,
          );
          return negative(Number(r.amountDiscountTotal ?? 0) || sumAttr28 || 0);
        },
      },
      {
        header: "Phí sàn cập nhật sau",
        width: 18,
        value: (r) => {
          let fee = Number(r.attributeValue7 ?? r.attribute17 ?? 0);
          if (isNaN(fee)) fee = 0;
          return negative(fee);
        },
      },
      { header: "Số tiền cần thanh toán", width: 18, value: (r) => r.amount || 0 },
      { header: "Đã trả", width: 16, value: (r) => r.paid || 0 },
      { header: "Còn nợ", width: 16, value: (r) => r.remaining || 0 },
      { header: "Mã voucher", width: 16, value: (r) => r.attribute39 ?? "" },
      { header: "Số hóa đơn", width: 16, value: (r) => r.attribute27 ?? "" },
      { header: "Xuất hóa đơn", width: 18, value: (r) => r.printInvoiceCheck ?? "" },
      { header: "Lý do hủy đơn", width: 30, value: (r) => r.attribute60 ?? "" },
    ];

    open();
    try {
      // Lấy theo từng trang để không treo API khi có nhiều đơn
      const all: any[] = [];
      for (let skip = 0; ; skip += pageSize) {
        const query = Object.entries({ ...params, Skip: skip, Take: pageSize })
          .filter(([, value]) => value !== undefined && value !== "")
          .map(
            ([key, value]) =>
              `${key}=${encodeURIComponent(value as string | number | boolean)}`,
          )
          .join("&");
        const res = await repositoryPos.get<MessageResponse<any>>(
          "/api/v1/CreateSellItem/get-list-order-cancel-tmdt?" + query,
        );
        if (!res || !res.success) {
          NotificationExtension.Fails("Export Excel thất bại !");
          return;
        }
        const lists: any[] = res.data?.pagedList?.lists ?? [];
        all.push(...lists);
        if (lists.length < pageSize || all.length >= (res.totalCount ?? 0)) break;
      }

      if (!all.length) {
        NotificationExtension.Fails("Không có dữ liệu để export !");
        return;
      }

      const sheet = XLSX.utils.aoa_to_sheet([
        columns.map((c) => c.header),
        ...all.map((r, i) => columns.map((c) => c.value(r, i))),
      ]);
      sheet["!cols"] = columns.map((c) => ({ wch: c.width }));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, "Danh sách hủy TMĐT");
      XLSX.writeFile(
        workbook,
        `danh_sach_huy_tmdt_${moment().format("YYYY_MM_DD_HHmmss")}.xlsx`,
      );
      NotificationExtension.Success(`Export thành công ${all.length} đơn !`);
    } catch (error) {
      console.error(error);
      NotificationExtension.Fails("Có lỗi khi export Excel !");
    } finally {
      close();
    }
  };

  // ===== Bộ lọc gọn =====
  const initialValues = form.getValues();

  // Ô tìm kiếm dùng chung: nhớ đang tìm theo trường nào
  const [searchBy, setSearchBy] = useState<string>(
    SEARCH_BY_OPTIONS.find((x) => (initialValues as any)[x.value])?.value ??
      "orderNumber",
  );
  const changeSearchBy = (next: string) => {
    if (next === searchBy) return;
    const current = (form.getValues() as any)[searchBy] ?? "";
    form.setFieldValue(searchBy as any, "");
    form.setFieldValue(next as any, current);
    setSearchBy(next);
  };

  // Ô ngày dùng chung: Ngày lập (khoảng) / Ngày hoàn thành / Ngày xuất kho
  const [dateType, setDateType] = useState<string>(
    initialValues.FinishDate
      ? "finish"
      : initialValues.OwDate
        ? "outward"
        : "create",
  );
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    initialValues.StartDate ?? null,
    initialValues.EndDate ?? null,
  ]);
  const changeDateRange = (value: [Date | null, Date | null]) => {
    setDateRange(value);
    form.setFieldValue("StartDate", value[0] as any);
    form.setFieldValue("EndDate", value[1] as any);
  };
  const changeDateType = (next: string) => {
    if (next === dateType) return;
    if (next === "create") {
      const start = new Date();
      start.setDate(start.getDate() - 9);
      start.setHours(0, 0, 0, 0);
      const end = new Date();
      end.setDate(end.getDate() + 1);
      end.setHours(0, 0, 0, 0);
      changeDateRange([start, end]);
    } else {
      changeDateRange([null, null]);
    }
    form.setFieldValue("FinishDate", null as any);
    form.setFieldValue("OwDate", null as any);
    setDateType(next);
  };

  // Bộ lọc nâng cao (ngăn bên phải)
  const [
    filterDrawerOpened,
    { open: openFilterDrawer, close: closeFilterDrawer },
  ] = useDisclosure(false);
  const [, setFilterTick] = useState(0);
  const refreshFilterChips = () => setFilterTick((x) => x + 1);

  const advancedFilters: {
    key: string;
    label: string;
    options?: { value: string; label: string }[];
  }[] = [
    { key: "saleChannelId", label: "Kênh bán", options: SALE_CHANNEL_OPTIONS },
    { key: "orderType", label: "Loại đơn hàng", options: orderTypes },
    { key: "orderStatus", label: "Trạng thái đơn hàng", options: orderStatuses },
    { key: "VourcherCode", label: "Mã voucher" },
    { key: "AttributeValue7", label: "Đối soát", options: RECONCILE_OPTIONS },
    { key: "IsAssigned", label: "Phân công", options: ASSIGN_OPTIONS },
    { key: "CodeSal", label: "Người hưởng số", options: listEmployeeSales },
    { key: "SalePhone", label: "SĐT người bán" },
  ];

  const currentValues = form.getValues() as any;
  const advancedChips = advancedFilters
    .filter((f) => currentValues[f.key])
    .map((f) => {
      const value = String(currentValues[f.key]);
      const text = f.options?.find((o) => o.value === value)?.label ?? value;
      return { key: f.key, label: `${f.label}: ${text}` };
    });

  const applyAdvancedFilters = () => {
    closeFilterDrawer();
    refreshFilterChips();
    fetchData();
  };

  const clearAdvancedFilters = (keys?: string[]) => {
    (keys ?? advancedFilters.map((f) => f.key)).forEach((key) =>
      form.setFieldValue(key as any, "" as any),
    );
    refreshFilterChips();
    if (!filterDrawerOpened) fetchData();
  };
  // ===== Hết bộ lọc gọn =====

  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />
      <div
        ref={headerRef}
        style={{ display: "flex", flexDirection: "column", gap: 10 }}
      >
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          <div>
            <Button
              leftSection={<IconReload size={14} />}
              variant="blue"
              disabled={!isHaveNewOrder}
              mr={"xs"}
              onClick={() => {
                fetchData();
                setIsHaveNewOrder(false);
              }}
            >
              Cập nhật đơn mới
            </Button>
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              onClick={async () => ExportExcel()}
            >
              Export Excel
            </Button>
          </div>
        </Flex>

        <Box
          style={{
            border: "1px solid #dee2e6",
            borderRadius: 8,
            padding: 12,
            background: "#fff",
          }}
        >
          <Flex gap={8} align="center" wrap="wrap">
            {/* Tìm kiếm chung: mã đơn, ghi chú, khách hàng, số hóa đơn, kho... (KeySearch) */}
            <TextInput
              key={form.key("keySearch")}
              aria-label="Tìm kiếm chung"
              w={220}
              placeholder="Tìm kiếm chung"
              title="Tìm theo mã đơn, khách hàng, ghi chú, số hóa đơn, kho..."
              leftSection={<IconSearch size={16} color="#868e96" />}
              {...form.getInputProps("keySearch")}
              onKeyDown={(e) => {
                if (e.key === "Enter") fetchData();
              }}
            />

            {/* Tìm theo: 1 ô thay cho Mã đơn / Mã KH / SĐT */}
            <Group gap={0} wrap="nowrap" w={280}>
              <Select
                aria-label="Tìm theo"
                w={130}
                allowDeselect={false}
                data={SEARCH_BY_OPTIONS}
                value={searchBy}
                onChange={(value) => value && changeSearchBy(value)}
                styles={{
                  input: {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    background: "var(--mantine-color-gray-0)",
                  },
                }}
              />
              <TextInput
                key={form.key(searchBy)}
                aria-label="Nội dung tìm kiếm"
                style={{ flex: 1 }}
                placeholder={
                  SEARCH_BY_OPTIONS.find((x) => x.value === searchBy)
                    ?.placeholder
                }
                leftSection={<IconSearch size={16} color="#868e96" />}
                styles={{
                  input: {
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderLeft: 0,
                  },
                }}
                {...form.getInputProps(searchBy)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") fetchData();
                }}
              />
            </Group>

            {/* Loại ngày: 1 ô thay cho Từ ngày / Đến ngày / Hoàn thành / Xuất kho */}
            <Group gap={0} wrap="nowrap" w={380}>
              <Select
                aria-label="Loại ngày"
                w={130}
                allowDeselect={false}
                data={DATE_TYPE_OPTIONS}
                value={dateType}
                onChange={(value) => value && changeDateType(value)}
                styles={{
                  input: {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    background: "var(--mantine-color-gray-0)",
                  },
                }}
              />
              {dateType === "create" ? (
                <DatePickerInput
                  type="range"
                  aria-label="Khoảng ngày lập"
                  style={{ flex: 1 }}
                  placeholder="Chọn khoảng ngày"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  allowSingleDateInRange
                  clearable
                  leftSection={<IconCalendar size={16} color="#868e96" />}
                  value={dateRange}
                  onChange={changeDateRange}
                  styles={{
                    input: {
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderLeft: 0,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                  }}
                />
              ) : (
                <DatePickerInput
                  key={form.key(dateType === "finish" ? "FinishDate" : "OwDate")}
                  aria-label={
                    dateType === "finish" ? "Ngày hoàn thành" : "Ngày xuất kho"
                  }
                  style={{ flex: 1 }}
                  placeholder="Chọn ngày"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  clearable
                  leftSection={<IconCalendar size={16} color="#868e96" />}
                  styles={{
                    input: {
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderLeft: 0,
                    },
                  }}
                  {...form.getInputProps(
                    dateType === "finish" ? "FinishDate" : "OwDate",
                  )}
                />
              )}
            </Group>

            <Select
              key={dataBranch.length || form.key("invId")}
              aria-label="Chi nhánh"
              w={170}
              searchable
              clearable
              placeholder="Tất cả chi nhánh"
              data={dataBranch.map((item) => ({
                label: item.att2 ? `${item.att2} - ${item.text}` : item.text,
                value: item.value,
              }))}
              {...form.getInputProps("invId")}
            />

            <MultiSelect
              key={form.key("Attribute12")}
              aria-label="Trạng thái chung"
              w={260}
              searchable
              clearable
              renderOption={renderCheckboxOption}
              placeholder="Trạng thái chung"
              data={dataStatusGeneral}
              {...form.getInputProps("Attribute12")}
            />


            <Button
              variant="default"
              leftSection={<IconAdjustmentsHorizontal size={16} />}
              onClick={openFilterDrawer}
              aria-haspopup="dialog"
              rightSection={
                advancedChips.length > 0 ? (
                  <Badge size="sm" circle>
                    {advancedChips.length}
                  </Badge>
                ) : undefined
              }
            >
              Bộ lọc
            </Button>

            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="filled"
              loading={isLoading}
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Flex>

          {advancedChips.length > 0 ? (
            <Group gap={6} mt={10}>
              {advancedChips.map((chip) => (
                <Badge
                  key={chip.key}
                  variant="light"
                  radius="xl"
                  size="lg"
                  tt="none"
                  fw={600}
                  pr={4}
                  rightSection={
                    <CloseButton
                      size="xs"
                      radius="xl"
                      variant="transparent"
                      aria-label={`Bỏ lọc ${chip.label}`}
                      onClick={() => clearAdvancedFilters([chip.key])}
                    />
                  }
                >
                  {chip.label}
                </Badge>
              ))}
              <Button
                variant="subtle"
                color="red"
                size="compact-sm"
                onClick={() => clearAdvancedFilters()}
              >
                Xóa lọc
              </Button>
            </Group>
          ) : null}
        </Box>
      </div>

      <Drawer
        opened={filterDrawerOpened}
        onClose={closeFilterDrawer}
        position="right"
        size={420}
        title={<Text fw={700}>Bộ lọc nâng cao</Text>}
      >
        <Stack gap="lg">
          <Stack gap="sm">
            <Text size="xs" fw={700} tt="uppercase" c="dark.4">
              Đơn hàng
            </Text>
            <Select
              key={form.key("saleChannelId")}
              label="Kênh bán"
              clearable
              placeholder="Tất cả"
              data={SALE_CHANNEL_OPTIONS}
              {...form.getInputProps("saleChannelId")}
            />
            <Select
              key={form.key("orderType")}
              label="Loại đơn hàng"
              searchable
              clearable
              placeholder="Tất cả"
              data={orderTypes}
              nothingFoundMessage="Dữ liệu không có !"
              renderOption={renderSelectOption}
              {...form.getInputProps("orderType")}
            />
            <SimpleGrid cols={2} spacing="sm">
              <Select
                key={form.key("orderStatus")}
                label="Trạng thái đơn hàng"
                clearable
                placeholder="Tất cả"
                data={orderStatuses}
                {...form.getInputProps("orderStatus")}
              />
            </SimpleGrid>
            <TextInput
              key={form.key("VourcherCode")}
              label="Mã voucher"
              placeholder="Nhập mã voucher"
              {...form.getInputProps("VourcherCode")}
            />
          </Stack>

          <Stack gap="sm">
            <Text size="xs" fw={700} tt="uppercase" c="dark.4">
              Xử lý đơn
            </Text>
            <Box>
              <Text size="sm" fw={500} mb={4}>
                Trạng thái đối soát
              </Text>
              <SegmentedControl
                key={form.key("AttributeValue7")}
                fullWidth
                data={RECONCILE_OPTIONS}
                {...form.getInputProps("AttributeValue7")}
              />
            </Box>
            <Select
              key={form.key("IsAssigned")}
              label="Tình trạng phân công"
              clearable
              placeholder="Tất cả"
              data={ASSIGN_OPTIONS}
              {...form.getInputProps("IsAssigned")}
            />
            <SimpleGrid cols={2} spacing="sm">
              <Select
                key={listEmployeeSales.length || form.key("CodeSal")}
                label="Người hưởng số"
                placeholder="Tìm nhân viên"
                data={listEmployeeSales}
                clearable
                searchable
                {...form.getInputProps("CodeSal")}
              />
              <TextInput
                key={form.key("SalePhone")}
                label="SĐT người bán"
                placeholder="Nhập SĐT"
                {...form.getInputProps("SalePhone")}
              />
            </SimpleGrid>
          </Stack>

          <Group justify="space-between" mt="md">
            <Button variant="default" onClick={() => clearAdvancedFilters()}>
              Xóa bộ lọc
            </Button>
            <Button color="blue" onClick={applyAdvancedFilters}>
              Áp dụng
            </Button>
          </Group>
        </Stack>
      </Drawer>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default ListOrderCancelTMDT;
